<cm-image-carousel [images]="images" [interval]="interval"></cm-image-carousel>
